import { getStore } from '../store/store';
import type { MailboxInfo } from 'owa-client-types';
import { SearchScopeKind } from 'owa-search-service/lib/data/schema/SearchScope';
import { getHasArchive, getAccountScopeUserSettings } from 'owa-session-store';
import { getModuleContextMailboxInfo } from 'owa-module-context-mailboxinfo';
import { getMailboxInfoForAuxArchive } from 'owa-mailbox-info/lib/getMailboxInfoForAuxArchive';

/**
 * Archive-fanout MailboxInfo for a single-account (primary-mailbox scope) search result whose source
 * guid indicates it lives in the account's archive; undefined when it is not an archive-fanout row.
 */
export default function getArchiveFanoutMailboxInfoForResult(
    mailboxGuids: string[] | null | undefined
): MailboxInfo | undefined {
    if (!getHasArchive(getModuleContextMailboxInfo())) {
        return undefined;
    }

    const { staticSearchScope, selectedMailboxInfo } = getStore();
    if (
        staticSearchScope?.kind !== SearchScopeKind.PrimaryMailbox ||
        !mailboxGuids ||
        mailboxGuids.length === 0
    ) {
        return undefined;
    }

    const currentMailboxInfo = selectedMailboxInfo ?? getModuleContextMailboxInfo();
    const primaryMailboxGuid =
        getAccountScopeUserSettings(currentMailboxInfo)?.SessionSettings?.MailboxGuid;
    if (!primaryMailboxGuid || mailboxGuids[0] === primaryMailboxGuid) {
        return undefined;
    }

    return getMailboxInfoForAuxArchive(currentMailboxInfo, mailboxGuids[0]);
}
